import { jsx as d } from "react/jsx-runtime";
import { Q as c } from "./themes-5f0b3c3d.mjs";
import { useRef as u } from "react";
import { u as a } from "./index-6a632112.mjs";
import { u as g } from "./uniqueId-321287e8.mjs";
const h = 8.33, l = a.div`
  width: 100%;
  height: auto;
  overflow: unset !important;

`, $ = a.div`
  width: calc(100% + ${({ $gutterWidth: t }) => t}px);
  display: flex;
  flex-wrap: wrap;
  height: auto;
  box-sizing: border-box;

  --gutter-width: ${({ $gutterWidth: t }) => t}px;
  row-gap: ${({ $rowGap: t }) => t}px;
`, i = (t) => {
  switch (t) {
    case 1:
    case 2:
    case 4:
    case 5:
    case 7:
    case 8:
    case 10:
    case 11:
      return h * t + "%";
    case 3:
      return "25%";
    case 6:
      return "50%";
    case 9:
      return "75%";
    default:
      return "100%";
  }
}, w = a.div`
  width: auto;
  min-width: ${h}%;
  flex-grow: 1;
  height: auto;
  box-sizing: border-box;
  padding-right: var(--gutter-width);
`, x = a.div`
  width: ${({ $s: t }) => i(t)};
  height: auto;
  box-sizing: border-box;
  padding-right: var(--gutter-width);

  @media ${c.tabletAndUp} {
    ${({ $m: t }) => ({ width: i(t) })};
  }
  @media ${c.laptopAndUp} {
    ${({ $l: t }) => ({ width: i(t) })};
  }
  @media ${c.desktopAndUp} {
    ${({ $xl: t }) => ({ width: i(t) })};
  }
`, m = ({
  children: t,
  gutterWidth: r = 12,
  style: e = {},
  className: o = "",
  rowGap: s = 8
}) => {
  const n = u(null), p = u(g("grid"));
  return /* @__PURE__ */ d(l, { children: /* @__PURE__ */ d(
    $,
    {
      id: p.current,
      ref: n,
      $gutterWidth: r,
      style: e,
      className: o,
      $rowGap: s,
      children: t
    }
  ) });
}, f = ({
  s: t = 12,
  m: r = 6,
  l: e = 4,
  xl: o = 3,
  children: s,
  style: n = {},
  className: p = ""
}) => /* @__PURE__ */ d(
  x,
  {
    $s: t,
    $m: r,
    $l: e,
    $xl: o,
    style: n,
    className: `grid-item ${p}`,
    children: s
  }
), b = ({
  className: t,
  style: r,
  children: e
}) => /* @__PURE__ */ d(w, { className: `grid-item ${t}`, style: r, children: e });
m.Item = f;
m.FlexItem = b;
export {
  m as Grid
};
